import React from "react";

import styles from "../../../styles/integrations.module.scss";

import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Button } from "../../components/Button";
import { CatalogAPI } from "../../../providers/CatalogAPI";
import { TextFileReaderIfood } from "../../components/TextFileReaderIfood";
import { Message } from "../../components/Message";
import { Label } from "../../components/Label";
import { Context } from "pages/Integrations";

export default class CatalogIFoodDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            active: true,
            merchantId: '',
            fileContent: null,
        };
    }

    componentDidMount() {
    }

    async updateAccount({ merchantId }) {
        const { fileContent } = this.state;

        this.setState({ loading: true });
        const updateResponse = await CatalogAPI.putImportCatalog(merchantId, fileContent?.content);

        if (updateResponse.getErrors([]).length > 0) {
            alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
            this.setState({ loading: false });
            return false;
        } else {
            alert({ text: "Cárdapio importado com sucesso", buttonText: "Ok" });
        }

        this.setState({ loading: false });

        return true;
    }


    render() {
        const { loading, merchantId, fileContent } = this.state;
        const { visible, onClose } = this.props;

        return (
            <Drawer
                visible={visible}
                onClose={onClose}
                closeInFade
                title="Importar cardapio do IFood"
            >
                <Context />

                <div className={styles.scrollContainer}>
                    <Input
                        design="two"
                        label="Merchant Id"
                        className="mb-20"
                        value={merchantId}
                        onChange={(e) => this.setState({ merchantId: e.target.value.trim() })}
                    />

                    {
                        fileContent ? (
                            <>
                                <Message type="default">
                                    {fileContent.name}
                                </Message>
                                <Button onClick={() => this.setState({ fileContent: null })} className="mt-20">
                                    Carregar outro arquivo
                                </Button>
                            </>
                        ) : (
                            <>
                                <Label>Selecione o arquivo CSV</Label>
                                <TextFileReaderIfood 
                                    onFileLoaded={(file) => this.setState({ fileContent: file })} 
                                    allowedFiles={"text/csv"}
                                />
                            </>
                        )
                    }

                    <div className={styles.footer}>
                        <Button
                            design="primary"
                            className="w-100"
                            onClick={() => this.updateAccount({ merchantId: merchantId })}
                            loading={loading}
                            disabled={loading}
                        >
                            Importar
                        </Button>
                    </div>
                </div>
            </Drawer>
        );
    }
}
